import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Modal from './components/Modal';
import Router from './router/Router';
import Theme from './services/Theme';

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => { Theme.setCSSVars(); }, []);

  // route enter animation
  useEffect(() => {
    const main = document.querySelector('main');
    if (!main) return;
    main.classList.remove('route-enter');
    // force reflow
    // eslint-disable-next-line no-unused-expressions
    main.offsetHeight;
    main.classList.add('route-enter');
  }, [pathname]);

  // smooth scroll to top on every route change (mobile-friendly)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <>
      <Header />
      <main>
        <Router />
      </main>
      <Footer />
      <Modal />
    </>
  );
};
export default App;
